import { useMainSurgeonDipsResources } from '~/storm'

export const useDipsSurgeons = () => {
    const dipsSurgeons = useMainSurgeonDipsResources()

    return dipsSurgeons.toSorted((a, b) => (a.shortName ?? '').localeCompare(b.shortName ?? ''))
}
